import { jsxs, jsx } from "react/jsx-runtime";
import KatexRenderer from "../../../utils/KatexRenderer.js";
import { cn } from "../../../lib/utils.js";
import { formatProblem } from "../../../utils/quiz-parser.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizImage, getStyles, PRINT_CORRECT_ANSWER_CLASS } from "./print-common.js";
function ExplanationPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const renderedProblem = quiz.problem ? formatProblem(
    quiz.problem,
    `${quizId}-print-problem`,
    () => null,
    quiz.additionalImages ?? void 0
  ) : [];
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    renderedProblem.length > 0 && /* @__PURE__ */ jsx("div", { className: s.problemArea, children: /* @__PURE__ */ jsx(
      "div",
      {
        "data-quiz-problem-text": true,
        className: cn(
          s.problemLine,
          compact ? "text-[15px] text-black tracking-[-0.09px] font-normal leading-[26px]" : s.problemText
        ),
        children: renderedProblem
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: s.problemArea, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "w-full min-h-[120px] border-[1.5px] border-[#ccc] border-solid rounded-[6px] bg-white",
        style: {
          backgroundImage: "repeating-linear-gradient(to bottom, transparent, transparent 31px, #e5e5e5 31px, #e5e5e5 32px)",
          backgroundPosition: "0 8px"
        },
        children: showCorrectAnswers && correctAnswers && correctAnswers.length > 0 && /* @__PURE__ */ jsx("div", { className: cn("p-[8px] text-[14px]", PRINT_CORRECT_ANSWER_CLASS), children: /* @__PURE__ */ jsx(KatexRenderer, { text: correctAnswers.join(", ") }) })
      }
    ) })
  ] });
}
export {
  ExplanationPrint
};
//# sourceMappingURL=explanation-print.js.map
